import { DreamStoreInterface, MyDreams } from 'sparkello-core';
import store from '@/store';

export class VuexDreamStore implements DreamStoreInterface {
  //Retrieves the MyDreams object from the state store
  public getMyDreams(): MyDreams {
    return store.state.myDreams;
  }

  //Sets the entire MyDreams object in the state store
  public setMyDreams(myDreams: MyDreams): void {
    store.commit('setMyDreamsList', myDreams);
  }

  //Updates the order of dreams in the MyDreams object
  public updateDreamOrder(myDreams: MyDreams): void {
    store.commit('setMyDreamsList', myDreams);
  }
}
